"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _emotion = require("../../utils/emotion");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var focusAnimation = (0, _emotion.keyframes)({
  '0%': {
    transform: 'scale(0)',
    opacity: 1
  },
  '100%': {
    transform: 'scale(2)',
    opacity: 0
  }
});
var FocusBox = function FocusBox(props) {
  var children = props.children;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var child = (0, _react.useMemo)(function () {
    var target = _react.Children.only(children);
    return target;
  }, [children]);
  var rippleClass = (0, _useCss["default"])(function (theme) {
    return {
      width: size,
      height: size,
      backgroundColor: theme.palette.accent.primary.color,
      borderRadius: '50%',
      animation: "".concat(focusAnimation, " 1.5s ease infinite")
    };
  });
  var rootClass = (0, _useCss["default"])(function (theme) {
    return {
      position: 'absolute',
      zIndex: 1,
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      backgroundColor: theme.color(theme.palette.accent.primary.contrast.low, 'transparent', 0.1)
    };
  });
  var parentClass = (0, _useCss["default"])(function () {
    return {
      position: 'relative',
      '&:focus-visible': _defineProperty({}, "& .".concat(rootClass), {
        display: 'flex'
      })
    };
  });
  var handleFocus = (0, _react.useCallback)(function (e) {
    var target = e.target;
    if (target instanceof HTMLElement) {
      var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;
      setSize(Math.max(width, height));
    }
  }, []);
  var cloneProps = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, child.props), {}, {
      className: (0, _emotion.cx)(child.props.className, parentClass),
      onFocus: function onFocus(e) {
        handleFocus(e);
        if (typeof child.props.onFocus === 'function') {
          child.props.onFocus(e);
        }
      }
    });
  }, [child, parentClass, handleFocus]);
  var element = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: rootClass,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: rippleClass
    })
  });
  return /*#__PURE__*/(0, _react.cloneElement)(child, cloneProps, child.props.children, element);
};
var _default = FocusBox;
exports["default"] = _default;